import { render, staticRenderFns } from "./ProuniOtherDocuments.vue?vue&type=template&id=45b3e58c&scoped=true&"
import script from "./ProuniOtherDocuments.vue?vue&type=script&lang=ts&"
export * from "./ProuniOtherDocuments.vue?vue&type=script&lang=ts&"
import style0 from "./ProuniOtherDocuments.vue?vue&type=style&index=0&id=45b3e58c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b3e58c",
  null
  
)

export default component.exports